import { render, staticRenderFns } from "./feedbackPage.vue?vue&type=template&id=a1a5157a"
import script from "./feedbackPage.vue?vue&type=script&lang=js"
export * from "./feedbackPage.vue?vue&type=script&lang=js"
import style0 from "./feedbackPage.vue?vue&type=style&index=0&id=a1a5157a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports